import type { PropsWithChildren } from "react";

import "./global.css";

export const TWStylesWrapper = ({ children }: PropsWithChildren) => children;
